export default "__VITE_ASSET__C3EqjHzu__"